// Base.jsx
import React from 'react'
import PropTypes from 'prop-types'

import styles from '../../../../css/notifications.module.css'

// eslint-disable-next-line import/prefer-default-export
const PopUp = function PopUp ({
  text,
  visible,
  textButton,
  functionButton,
  primaryButton = false,
}) {
  let classValue = styles.notificationPopUp
  let overlayValue = styles.overlay
  if (!visible) {
    classValue = `${styles.notificationPopUp} ${styles.hidden}`
    overlayValue = `${styles.overlay} ${styles.hidden}`
  }

  let buttonDisplay
  if (textButton) {
    buttonDisplay = (
      <div className={styles.modalSave}>
        <button
          className={primaryButton ? styles.notificationPrimaryButton : styles.notificationSaveButton}
          onClick={functionButton}
          type='button'
        >
          {textButton}
        </button>
      </div>
    )
  }

  return (
    <div>
      <div className={overlayValue} />
      <div className={classValue}>
        <div className={`${styles.popUpText} ${styles.modalHead}`}>
          {text}
          {buttonDisplay}
        </div>
      </div>
    </div>
  )
}

PopUp.propTypes = {
  text: PropTypes.string,
  visible: PropTypes.bool,
  textButton: PropTypes.string,
  functionButton: PropTypes.func,
  primaryButton: PropTypes.bool,
}

export default PopUp
